import { Injectable } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CommonService } from './common.service';
import { CommonBookingService } from 'src/app/bookings/shared/common-booking.service';
import { AuthService } from './auth.service';
import { UtilService } from './util.service';
import { BaseFormGroup } from '../form-input-components/base-form-group';
import { indiaPhoneValidator, phoneValidator } from 'src/app/shared/validators/phone-validator';
import { FormConstants } from 'src/app/core/globals/form-constants';
import { customMandatoryValidator } from '../validators/custom-mandatory-validator';
import { secureValidator } from '../validators/secure-validator';
import { emailValidator } from '../validators/email-validator';
import { CreateBookingService } from 'src/app/bookings/create-booking/create-booking.service';
import { combineLatest } from 'rxjs';



@Injectable({
  providedIn: 'root'
})
export class AddRiderService extends BaseFormGroup {

  config:any
  public formConfig: any[] = [];
  public emplIdConfig: any;
  public costCenterConfig: any;
  isPhoneCodeConfigVisibile: boolean;
  public searchConfig: any;
  private actionControlConfig: any[] = [];
  engagementConfig: any;
  payerConfig: any;
  public costCenters: any[];
  public departmentList: any[];
  public payeeOptions: any[] = [];
  public selectedPayer;
  public paymentType: any;
  departmentListName: any = [];
  public costCenterNames: any[];
  currentUser:any
  miscelleneousConfig:any
  etsValuesMandatory = false;
  riderTypeMapping:any
  public riderStateArray: any[] = [];
  alternateMobileMandatory:boolean=false;
  phoneNumberInEtsMandatory = {};

  isSelfRider: boolean;
  riderLimitReached:boolean=false;
  riderLimit:number;
  formArray
  duplicateRiderMsg:string
  showDuplicateRiderError:boolean=false

  
  constructor( private commonService: CommonService, 
     private commonBookingService: CommonBookingService,
      private authService: AuthService,
      private utilService: UtilService, private formBuilder: FormBuilder,  private createBookingService: CreateBookingService,) { super() }

  setConfig(config){
    this.config=config
  }

  setMiscConfig(config){
    this.miscelleneousConfig=config
  }

  setRiderTypeMapping(mapping){
  this.riderTypeMapping=mapping
  }

  setFormArray(formArray){
    this.formArray=formArray
  }

  getFormArray(){
       return this.formArray
  }

  getRiderLimit(){
   return this.commonService.workflowConfig?.riderLimit;
  }

  getConfig() {
    this.formConfig = [];
    for (const element of this.config.elementConfigList) {
      if (element.elementKey !== 'RiderSearch' && element.config.elementType !== 'button' &&
        element.elementKey !== 'Rider Serial Number' && element.elementKey !== 'phoneCode') {
        this.formConfig.push(element);
      }
      if (element.elementKey === 'emplId') {
        this.emplIdConfig = element;
      }
      if (element.elementKey === 'phoneCode') {
        this.isPhoneCodeConfigVisibile = element.config.visibility.visible;
        if (element.config.visibility.visible) {
          this.formConfig.push(element);
        }
      }
      if (element.elementKey === 'costCenter') {
        this.costCenterConfig = element;
      }
      if (element.elementKey === 'RiderSearch') {
        this.searchConfig = element;
      }
      if (element.elementKey === 'RiderSearch' || element.config.elementType === 'button') {
        this.actionControlConfig.push(element);
      }
      if (element.elementKey === 'payer') {
        this.payerConfig = element;
      }
      if (element.elementKey === 'engagementCode'){
        this.engagementConfig = element;
      }
  
    }
    if (this.formArray.value.length) {
      this.constructPayeeForm(this.formArray);
    }
  
  }

  constructPayeeForm(payeeForm) {
    if (this.payerConfig && this.payerConfig.config.visibility.visible && this.paymentType === 'Bill To User') {
      const payeeArr = [];
      let payeeObj = {};
      let payerGuid = null;
      for (const payee of payeeForm.controls) {
        if (payee.controls['payerGuid'].value || payee.value.payerGuid) {
          payerGuid = payee.controls['payerGuid'].value || payee.value.payerGuid;
        }
        if (payee instanceof FormGroup) {
          payeeObj = { payerType: payee.controls['riderTypeId'].value, value: payee.controls['emplGuid'].value };
          payeeArr.push(payeeObj);
        }
      }
      this.payeeOptions = payeeArr;
      this.selectedPayer = this.selectedPayer ? this.selectedPayer : payerGuid ?
        payerGuid : this.payeeOptions[0] && this.payeeOptions[0].value;
      this.commonBookingService.getSelectedPayer(this.selectedPayer);
    }
  }

  getCostCenters() {
    this.commonService.getEtsData().subscribe((response) => {
      this.commonService.costcenter.next(response.costCenters);
      this.commonService.costcenter.subscribe(response => {
        this.costCenters = response;
        this.costCenterNames = this.costCenters.map((costCenter: any) => {
          return costCenter.name;
        });
      });
      this.getCurrentUser();
    });
  }

  getDepartments() {
    this.commonService.getEtsData().subscribe((response) => {
        this.departmentList = response.departments;
        this.departmentListName = response.departments.map((departmemt: any) => {
          return departmemt.name;
        });
    });
  }

  updateRequester(requester: any) {
    this.updateTableWithRider(requester);
  }

  getCurrentUser() {
        this.currentUser = this.authService.user.info.employee
    if (this.miscelleneousConfig && this.miscelleneousConfig['etsValuesMandatory']) 
            this.etsValuesMandatory = this.miscelleneousConfig['etsValuesMandatory'] === 'false' ? false : true;
        this.setupForm();
         }


  addSelfAsRider() {
    this.updateTableWithRider(this.formatRiderInfo(this.currentUser, this.getSelfKey()));
    if (this.etsValuesMandatory && this.getConfigForElementKey(this.formConfig, 'mobile').config.visibility.visible) 
      this.checkMobileNumberInEts(0);
    
  }

  setupForm() {
    if ( !this.formArray.length  && this.commonService.workflowConfig?.addSelfAsDefaultRider) {
  this.addSelfAsRider();
  
  }else{
  this.formArray.controls.forEach((formGroup) => {
   this.riderStateArray.push({
     isEditActive: false
   });
   this.setEmplIdValidator(formGroup, formGroup.get('riderType').value);

  });
  }
  }

  formatRiderInfo(riderDetails: any, riderType: string): any {    
    const mobileAndCountryCode = this.getPhoneAndCountryCode(riderDetails.phone);
    return {
      riderType,
      riderTypeId: this.getRiderTypeID(riderType),
      name: riderDetails.employeeName ,
      emplId: riderDetails.employeeId ,
      gender: this.utilService.capitalizeString(riderDetails.gender),
      department:  this.getCostCenterAndDepartmemntLabelFromValue(riderDetails.departmentGuid,true) ,
      costCenter: this.getCostCenterAndDepartmemntLabelFromValue(riderDetails.costCenterGuid)      ,
      email: riderDetails.emailId,
      mobile: mobileAndCountryCode[1],
      phoneCode: mobileAndCountryCode[0],
      emplGuid: riderDetails.guid ,
      payerGuid: this.selectedPayer,
      designation: riderDetails.jobTitle,
      officeGuid: riderDetails.office.guid,
      businessUnit: riderDetails.businessUnit,
      billingEntity:riderDetails.billingEntity,
      gstCode:riderDetails.gstCode,
      companyCode:riderDetails.companyCode,
      baseOfficeLocation:riderDetails?.baseOfficeLocation,
      designationCode:riderDetails.designationCode,
      officeCode:riderDetails.officeCode,
      serviceAreaDesc:riderDetails.serviceAreaDesc,
      functionDesc:riderDetails.functionDesc,
      subFunctionDesc:riderDetails.subFunctionDesc,
      jobTitle:riderDetails.jobTitle
     
    };
  }
  getPhoneAndCountryCode(mobile, code?: string): string[] {
    let phoneCode = "";
    let phoneNumber = "";
    if (mobile && !mobile.startsWith("+")) {
      if (code && code !== "") {
        phoneCode = code;
      } else {
        phoneCode = "+91";
      }
      phoneNumber = mobile;
    } else {
      if (mobile) {
        const phoneWithCode = mobile.split('-');
        phoneCode = phoneWithCode[0];
        phoneNumber = phoneWithCode[1];
      }
    }
    return [phoneCode, phoneNumber];
  }
  getCostCenterAndDepartmemntLabelFromValue(value: string, isDepartment: boolean = false): string {
    let temp = this.costCenters;
    if(isDepartment){
      temp = this.departmentList;
    }
    if(temp?.length){
      for (const elememt of temp) {
        if (elememt.guid === value) {
          return elememt.name;
        }
      }
    }
  }
  setEmplIdValidator(riderForm: any, riderTypeId: string) {
    const parent = riderForm;
    let tempEmplIdConfig;
    let tempCostCenterConfig;
    const emplIdControl = parent.get('emplId');
    const costCenterControl = parent.get('costCenter');
    if (emplIdControl) {
      if (riderTypeId === 'Guest') {
        tempEmplIdConfig = Object.assign({}, this.emplIdConfig.config, { mandatory: false });
        tempCostCenterConfig = Object.assign({}, this.costCenterConfig.config, { mandatory: false });
      } else {
        tempEmplIdConfig = this.emplIdConfig.config;
        tempCostCenterConfig = this.costCenterConfig.config;
      }
      emplIdControl.setValidators(this.getValidations(tempEmplIdConfig, parent));
      emplIdControl.updateValueAndValidity();
  
      costCenterControl.setValidators(this.getValidations(tempCostCenterConfig, parent));
      costCenterControl.updateValueAndValidity();
    }
  }
  getValidations = (fieldConfig: any, formGroup: FormGroup): any[] => {
    const validations = [];
    if (fieldConfig.mandatory) {
      if (fieldConfig.visibility.elementKey) {
        validations.push(customMandatoryValidator.bind(this, fieldConfig, formGroup));
      } else {
        validations.push(Validators.required);
      }
    }
  
    if (fieldConfig.elementType === FormConstants.elementTypes.text
        || fieldConfig.elementType === FormConstants.elementTypes.dropdownAndInput
        || fieldConfig.elementType === FormConstants.elementTypes.dropdownAndSearchAndInput) {
      validations.push(secureValidator);
    }
  
    if (fieldConfig.elementType === FormConstants.elementTypes.incrementor && fieldConfig.values.length) {
      validations.push(Validators.max(Number(fieldConfig.values[0])));
    }
  
    if (fieldConfig.regex) {
      if (fieldConfig.regex === 'email_check') {
        validations.push(emailValidator);
      } else if (fieldConfig.regex === 'phone_check') {
        validations.push(phoneValidator);
      } else {
        const generalRegex = new RegExp(fieldConfig.regex);
        validations.push(Validators.pattern(generalRegex));
      }
    }
    return validations;
  }
  getConfigForElementKey(config: any, elementKey: string): any {
    if (config.elementKey === elementKey) {
      return config;
    }
    if (config.pageConfigList) {
      for (const page of config.pageConfigList) {
        const hasMatch = this.getConfigForElementKey(page, elementKey);
        if (hasMatch) { return hasMatch; }
      }
    } else if (config.sectionConfigList) {
      for (const section of config.sectionConfigList) {
        const hasMatch = this.getConfigForElementKey(section, elementKey);
        if (hasMatch) { return hasMatch; }
      }
    } else if (config.elementConfigList) {
      for (const element of config.elementConfigList) {
        const hasMatch = this.getConfigForElementKey(element, elementKey);
        if (hasMatch) { return hasMatch; }
      }
    } else if (config instanceof Array) {
      for (const element of config) {
        const hasMatch = this.getConfigForElementKey(element, elementKey);
        if (hasMatch) { return hasMatch; }
      }
    }
    return false;
  }
  checkMobileNumberInEts(index) {
    setTimeout(() => {
      if (this.getConfigForElementKey(this.formConfig, 'mobile').config.visibility.visible) {
        this.phoneNumberInEtsMandatory[index] = false;
        if (this.formArray.controls[index].get('riderTypeId').value !== 'Firm Member'
          && !this.formArray.controls[index].get('mobile').value) {
          this.phoneNumberInEtsMandatory[index] = true;
          this.formArray.controls[index].get('mobile').setErrors({ etsMobileMandate: true });
          this.formArray.controls[index].get('mobile').markAsDirty();
        }
      }
    }, 0);
  }

  updateTableWithRider(riderInfo?: any) {
    
    // check if added rider is self
  if (riderInfo && riderInfo.riderTypeId === 'Self') {
  riderInfo.riderTypeId = 'Self';
  this.isSelfRider = true;
  }
  
  // when a rider already in the table is added
  if (riderInfo) {
  for (const control of this.formArray.controls) {
            if (riderInfo.emplId === control.value.emplId) {
      control.patchValue(riderInfo);
      return;
    }
  }
  }
  
  // when new rider is added
  const formDetails = this.addNewRider(riderInfo);
  this.addRiderState(formDetails, riderInfo);
  }

  setAlternateNumberVisibility(value){
    if(value){
      const alternateMobileElement = this.config.elementConfigList.find(element => element.elementKey === "alternateMobile");
      if (alternateMobileElement) 
          this.alternateMobileMandatory = alternateMobileElement.config.mandatory;
    }
  }

  addNewRider(riderInfo?: any): FormGroup {
    const travellerId = this.utilService.generateUuid();
    const formDetails: any = this.formBuilder.group({
   travellerId,
   isNew: true,
   riderType: this.getFirmMemberKey()
  });
    this.constructForm(formDetails, this.formConfig);
    formDetails.addControl('emplGuid', new FormControl(''));
    formDetails.addControl('payerGuid', new FormControl(''));
    formDetails.addControl('officeGuid', new FormControl(''));
    formDetails.addControl('designation', new FormControl(''));
    formDetails.addControl('riderTypeId', new FormControl('Guest'));
    formDetails.addControl('jobTitle', new FormControl(''));
    if (riderInfo) 
    formDetails.patchValue(riderInfo);
  
    this.createBookingService.newRiders.push(travellerId);
    this.formArray.push(formDetails);
    if (this.commonService.workflowConfig?.hideOtherRiderMobileNumber && riderInfo){
  for (const config of this.formConfig) {
   if (['mobile', 'alternateMobile'].includes(config.elementKey)){
     if (this.currentUser && this.currentUser?.employeeId !== riderInfo.emplId){
       formDetails.controls[config.elementKey].isHidden = true;
     }else{
       formDetails.controls[config.elementKey].isHidden = false;
     }
   }
  }
  }
    this.constructPayeeForm(this.formArray);
  
    if (this.commonService.workflowConfig.riderLimit) 
   this.riderLimitReached = this.formArray.length == this.commonService.workflowConfig.riderLimit ? true : false;
  
 
    return formDetails;
  }

  addRiderState(formDetails: FormGroup, riderInfo?: any) {
    // check if there are any empty fields
    let emptyFieldsCount = 0;
    if (riderInfo) {
      for (const field of this.formConfig) {
        if (formDetails.get(field.elementKey)) {
          if (!formDetails.get(field.elementKey).value) {
            emptyFieldsCount++;
          } else {
            if (!['costCenter', 'department', 'alternatePhoneCode','phoneCode'].includes(field.elementKey)){
              formDetails.get(field.elementKey).disable({ onlySelf: true });
            }
          }
        }
      }
      if (!emptyFieldsCount) {
        formDetails.disable({ onlySelf: true });
      }
    }
  
    // add to formArray and riderStateArray
    this.riderStateArray.push({
      isEditActive: !riderInfo ? true : (emptyFieldsCount ? true : false)
    });
  }

 

  getGuestKey(){
    const keyObject = this.riderTypeMapping?.find(rider => rider.value === 'Guest');
    if (keyObject) {
       return keyObject.label;
    }
  }

  getFirmMemberKey(){
    const keyObject = this.riderTypeMapping?.find(rider => rider.value === 'Firm Member');
    if (keyObject) {
       return keyObject.label;
    }
    }
  
  getSelfKey(){
   
    const keyObject =this.riderTypeMapping? this.riderTypeMapping.find(rider => rider.value === 'Self') : 'Self';
    if (keyObject) {
       return keyObject.label;
    }
  }

  getRiderTypeID(type){
    const item = this.riderTypeMapping?.find(item => item.label === type); 
    return item ? item.value : undefined;
    
  }
}
